export default {
  showNotification: (type, message) => showNotification(type, message)
};

function showNotification(type, message) {
  const nc = document.getElementById("notification-container");
  nc[type](message);
}
